import { takeLatest, call, put, all } from "redux-saga/effects";
import { showSuccess, showError } from "../../../utils/snackbarRef";

import history from "../../../services/history";
import api from "../../../services/api";

import {
  updateProfileSuccess,
  updateProfileFailure,
  updateFirstStepsSuccess,
  updateFirstStepsFailure,
  updateOfficeSuccess,
  updateOfficeFailure,
  updateProfileEmpresaSuccess,
  updateProfileEmpresaFailure,
} from "./actions";

export function* updateProfile({ payload }) {
  try {
    const raw = payload.data;
    // Filtrar apenas campos editáveis — evitar enviar metadados do Sequelize/Redux
    const allowed = [
      "name", "email", "telefone", "data_nascimento", "cpf", "cep", "rua",
      "numero", "bairro", "municipio", "complemento", "estado", "genero",
      "nome_social", "sobre_mim", "ocupacao", "foco_carreira", "linkedin",
      "github", "outro", "skills", "experiences", "languages", "portfolio",
      "accept_privacy_policies", "password", "oldPassword", "confirmPassword",
      "notificacoes", "avatar_url",
      "grau_instrucao", "renda_familiar", "raca_cor", "deficiencia",
    ];
    const data = {};
    for (const key of allowed) {
      if (raw[key] !== undefined) data[key] = raw[key];
    }

    const response = yield call(api.put, "aluno/update", data);

    const profile = response.data?.dataValues || response.data;
    yield put(updateProfileSuccess(profile));

    showSuccess("Perfil atualizado com sucesso!");
  } catch (err) {
    showError(err?.response?.data?.error || "Erro ao atualizar perfil");
    yield put(updateProfileFailure());
  }
}

export function* finishProfile({ payload }) {
  try {
    const response = yield call(
      api.put,
      `aluno/finished/${payload.data.id_hash}`,
      payload.data.validationData
    );

    const profile = response.data?.dataValues || response.data;
    yield put(updateProfileSuccess(profile));

    showSuccess("Perfil atualizado com sucesso!");

    history.push("/");
  } catch (err) {
    showError(err?.response?.data?.error || "Erro ao finalizar perfil");
    yield put(updateProfileFailure());
  }
}

export function* updateProfileEmpresa({ payload }) {
  try {
    const response = yield call(api.put, "empresa/update", payload.data);

    yield put(updateProfileEmpresaSuccess(response.data));

    showSuccess("Cadastro atualizado com sucesso!");

    // Sem redirecionar: a tela /empresa-account tem barra fixa de salvar e o
    // usuário continua editando depois de gravar. O `history.push("/")` que
    // existia aqui também jogava a empresa para a raiz quando ela só trocava a
    // logo pela Sidebar, que dispara esta mesma saga.
  } catch (err) {
    showError(err?.response?.data?.error || "Erro ao atualizar cadastro");
    yield put(updateProfileEmpresaFailure());
  }
}

export function* updateFirstSteps({ payload }) {
  try {
    const { data } = payload;

    const response = yield call(api.patch, "updatefirststeps", data);

    yield put(updateFirstStepsSuccess(response.data));
  } catch (err) {
    yield put(updateFirstStepsFailure());
  }
}

export function* updateOffice({ payload }) {
  try {
    const { data } = payload;

    const response = yield call(api.put, "escritorio", data);

    yield put(updateOfficeSuccess(response.data));

    showSuccess("Perfil atualizado com sucesso!");

    history.push("/escritorio");
  } catch (err) {
    yield put(updateOfficeFailure());
  }
}

export function* seeNotifications({ payload }) {
  try {
    const { user, url } = payload;
    yield call(api.patch, url, user);
  } catch (err) {
    // erro silenciado
  }
}

export default all([
  takeLatest("@user/FINISH_PROFILE_REQUEST", finishProfile),
  takeLatest("@user/UPDATE_PROFILE_REQUEST", updateProfile),
  takeLatest("@user/UPDATE_FIRST_STEPS_REQUEST", updateFirstSteps),
  takeLatest("@user/UPDATE_OFFICE_REQUEST", updateOffice),
  takeLatest("@user/UPDATE_PROFILE_EMPRESA_REQUEST", updateProfileEmpresa),
  takeLatest("@user/SEE_NOTIFICATIONS", seeNotifications),
]);